/**
 * Centralized theme constants for AI-related components
 * This file contains all colors, gradients, and design tokens used across AI features
 */

export const AI_COLORS = {
  primary: '#667eea',
  secondary: '#764ba2',
  accent: '#f093fb',
  text: {
    primary: '#333',
    secondary: '#555',
    tertiary: '#666',
    light: '#777777',
  },
  background: {
    light: '#f5f7fa',
    white: '#ffffff',
  },
  border: {
    light: '#e0e0e0',
    medium: '#d3d3d3',
  },
  status: {
    recording: '#ef4444',
    recordingHover: '#dc2626',
    recordingDark: '#b91c1c',
    success: '#10b981',
    successHover: '#059669',
    successDark: '#047857',
    neutral: '#64748b',
    neutralHover: '#475569',
    neutralDark: '#334155',
  },
};

export const AI_GRADIENTS = {
  primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  primaryReverse: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
  text: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)',
  backgroundLight: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
  backgroundLightHover: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
  shimmer: 'linear-gradient(90deg, transparent, transparent, rgba(255, 255, 255, 0.9), transparent, transparent)',
  recording: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  recordingHover: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
  success: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  successHover: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
  neutral: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
  neutralHover: 'linear-gradient(135deg, #475569 0%, #334155 100%)',
  audioControls: 'linear-gradient(to right, #fafafa, #ffffff)',
};

export const AI_SHADOWS = {
  card: '0 20px 40px rgba(0, 0, 0, 0.3)',
  button: '0 4px 12px rgba(102, 126, 234, 0.3)',
  buttonHover: '0 6px 16px rgba(102, 126, 234, 0.4)',
  recording: '0 4px 12px rgba(239, 68, 68, 0.3)',
  recordingHover: '0 6px 16px rgba(239, 68, 68, 0.4)',
  success: '0 4px 12px rgba(16, 185, 129, 0.3)',
  successHover: '0 6px 16px rgba(16, 185, 129, 0.4)',
  neutral: '0 4px 12px rgba(100, 116, 139, 0.3)',
  neutralHover: '0 6px 16px rgba(100, 116, 139, 0.4)',
  light: '0 2px 8px rgba(102, 126, 234, 0.15)',
  hover: '0 4px 12px rgba(102, 126, 234, 0.15)',
};

export const AI_BORDERS = {
  light: '1px solid #e0e0e0',
  primary: '1px solid rgba(102, 126, 234, 0.2)',
  primaryHover: '1px solid rgba(102, 126, 234, 0.3)',
  white: '1px solid rgba(255, 255, 255, 0.2)',
};

export const AI_BORDER_RADIUS = {
  small: '8px',
  medium: '12px',
  large: '20px',
  circle: '50%',
};

export const AI_SPACING = {
  xs: 0.5,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
};

export const AI_TRANSITIONS = {
  default: 'all 0.3s ease',
  fast: 'all 0.2s ease-in-out',
};

export const AI_FILTERS = {
  blur: {
    light: 'blur(4px)',
    medium: 'blur(10px)',
  },
  dropShadow: {
    light: 'drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3))',
    medium: 'drop-shadow(0 2px 8px rgba(102, 126, 234, 0.6)) drop-shadow(0 0 12px rgba(102, 126, 234, 0.4))',
  },
};
